import React, { useEffect } from 'react';
import { getWeeklyWeather } from 'Redux/Weather/reducer';
import { useAppDispatch } from 'Redux/store';
import { useSelector } from 'react-redux';
import {
  selectCurrentOrder,
  selectOrderLoading,
  selectOrderError,
} from 'Redux/Order/slice';
import {
  selectWeeklyWeather,
  selectWeatherLoading,
  selectWeatherError,
} from 'Redux/Weather/slice';
import { Alert, Spin } from 'antd';
import { timestampToDayName, getDatesRange } from 'Shared/Utils';
import DynamicSVG from 'Components/UI/DynamicSVG';
import styles from './Weather.module.scss';

export const Weather: React.FC = () => {
  const currentOrder = useSelector(selectCurrentOrder);
  const weeklyWeather = useSelector(selectWeeklyWeather);
  const orderIsLoading = useSelector(selectOrderLoading);
  const orderError = useSelector(selectOrderError);
  const weatherIsLoading = useSelector(selectWeatherLoading);
  const weatherError = useSelector(selectWeatherError);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (currentOrder) {
      dispatch(getWeeklyWeather({ location: currentOrder.deliver_to }));
    }
  }, [currentOrder, dispatch]);

  return (
    <>
      <div className={styles.weather}>
        {!!weeklyWeather.length ? (
          <>
            <div className={styles.weather__title}>
              <span className={styles.weather__title__range}>
                {getDatesRange({ daysFromToday: 6 })}
              </span>
              <span className={styles.weather__title__location}>
                {currentOrder?.deliver_to}
              </span>
            </div>
            <ul className={styles.weather__days}>
              {weeklyWeather.map(({ timestampInSec, tempInF, icon }) => {
                return (
                  <li key={timestampInSec} className={styles.weather__day}>
                    <span className={styles.weather__day__title}>
                      {timestampToDayName(timestampInSec)}
                    </span>
                    <span className={styles.weather__day__icon}>
                      <DynamicSVG fileName={icon} assetsDirectory="weather/" />
                    </span>
                    <span className={styles.weather__day__temperature}>
                      {`${tempInF}°F`}
                    </span>
                  </li>
                );
              })}
            </ul>
          </>
        ) : (
          <Alert
            message={
              orderIsLoading || weatherIsLoading
                ? 'Weather is loading...'
                : (orderError || weatherError || !weeklyWeather) &&
                  'No weather data available'
            }
            type="info"
            showIcon
          />
        )}
      </div>
    </>
  );
};
